module.exports = __webpack_public_path__ + "static/media/birth-cert-step4.8209d4cd.png";